module.exports = __webpack_public_path__ + "img/close.bf5c2946.svg";